export function extractData(barData, dataStruct) {
  if (barData === "problem with bins list") 
    return []
  if (barData !== undefined && barData !== "problem with bins list") {
    dataStruct = barData;
    return dataStruct
  }
}